export enum LinkTarget {
  Self = '_self',
  Blank = '_blank',
  Modal = 'modal',
  Post = 'post',
}

export default LinkTarget;
